import * as React from "react";
import { useClientId } from "./ClientConfig";
import { Feature, featureEnabled } from "./client-features";

export const useFeatureEnabled = (feature: Feature): boolean => {
  return featureEnabled(useClientId(), feature);
};

export const IfFeatureEnabled: React.FC<{
  feature: Feature;
  children: React.ReactNode;
}> = ({ feature, children }) => {
  return useFeatureEnabled(feature) ? children : null;
};
